export const selectMenu = state => state.menu.isMenuOpen;
export const selectSubMenu = state => state.menu.isSubMenuOpen;
export const selectThirdMenu = state => state.menu.isThirdMenuOpen;
export const selectCart = state => state.menu.isCartOpen;
